export * from './space-record-functional-methodology'
